export default __webpack_public_path__ + "static/media/bannerImgSupport.ee5261c6.png";